import { render, staticRenderFns } from "./create-pick-wave.vue?vue&type=template&id=2e1f2ba7&scoped=true&"
import script from "./create-pick-wave.vue?vue&type=script&lang=ts&"
export * from "./create-pick-wave.vue?vue&type=script&lang=ts&"
import style0 from "./create-pick-wave.vue?vue&type=style&index=0&id=2e1f2ba7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1f2ba7",
  null
  
)

export default component.exports